import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../components/Button'
import StartDateFields from '../../../../ReusableFormFields/StartTimeFields'

import { START_DATE, START_TIME } from '../../../../Multiplatform/LineItemForms/fields'

import useStepFormStyles from '../../../../../styles/common/stepForms'

const stepFields = [START_TIME, START_DATE]

const StartTimeStep = ({ formik, handleStepChange }) => {
  const stepFormClasses = useStepFormStyles()

  const { t } = useTranslation()

  const handleContinue = () => {
    handleStepChange(stepFields)
  }

  return (
    <>
      <div className={stepFormClasses.stepTitle}>{t('When would you like the ad sets to start?')}</div>
      <StartDateFields formik={formik} />
      <div className={stepFormClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default StartTimeStep
